import { useEffect, useState } from "react";

const InputField = ({
  type = "text",
  label = "",
  inputClass = "",
  wrapperClassName = "",
  percentage = false,
  labelClass = "mb-1",
  change = () => {},
  blur = () => {},
  touch = () => {},
  placeholder = "",
  value = "",
  min = 0,
  max = "",
  name = "",
  id = "",
  step = "",
  error = false,
  touched = false,
  decimal = false,
  ariaLabel = "",
  errorClassName = "",
  maxLength,
  children,
  disabled,
  showDollarSign,
  isTextarea = false,
  rows = 4,
}) => {
  const [inputState, setInputState] = useState(value);

  function onChange(e) {
    setInputState(e.target.value);
    change(e.target.value);
  }
  function onBlur(e) {
    let val = e.target.value;

    if (percentage) {
      val = parseFloat(val).toFixed(2);
      val = val === "NaN" ? "0.00" : val;
      if (val > parseFloat(max)) {
        val = parseFloat(max).toFixed(2);
      } else if (val < parseFloat(min) && val > -1) {
        val = parseFloat(min).toFixed(2);
      }

      if (decimal) val = parseFloat(val).toFixed(2);
      else val = parseInt(val).toFixed(2);

      setInputState(val);
      blur(val);
    } else if (type === "number" && (max || min)) {
      if (val === "") {
        setInputState("");
        blur("");
        return;
      }

      val = decimal ? parseFloat(val) : parseInt(val);

      if (val > parseInt(max)) {
        val = max;
      } else if (val < parseInt(min)) {
        val = min;
      }
      onChange({
        target: {
          value: decimal ? parseFloat(val).toFixed(2) : parseInt(val),
        },
      });
    } else {
      blur(val);
    }
  }
  useEffect(() => {
    if (percentage) {
      setInputState(parseFloat(value).toFixed(2));
    } else {
      setInputState(value);
    }
  }, [value]);

  return (
    <div className={`inputField form-group ${wrapperClassName}`}>
      {label && (
        <label className={`form-label input-label ${labelClass}`} htmlFor={id}>
          {label}
        </label>
      )}
      <div className="d-flex align-items-center">
        {showDollarSign && <span className="dollar">$</span>}

        {isTextarea ? (
          <textarea
            className={`form-control ${inputClass} ${
              error && touched ? "is-invalid" : ""
            }`}
            placeholder={placeholder}
            name={name || id}
            id={id}
            rows={rows}
            value={inputState}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={maxLength}
            aria-label={ariaLabel}
            onFocus={touch}
            disabled={disabled}
          />
        ) : (
          <input
            type={type}
            className={`form-control ${inputClass} ${
              error && touched && "is-invalid"
            }`}
            placeholder={placeholder}
            name={name || id}
            id={id}
            value={inputState}
            onChange={onChange}
            onBlur={onBlur}
            min={min}
            max={max}
            maxLength={maxLength}
            step={step}
            aria-label={ariaLabel}
            autoComplete="new-password"
            onFocus={touch}
            disabled={disabled}
          />
        )}
      </div>
      {percentage && <div className="percentage">%</div>}
      {children}
      {error && touched && (
        <span className={`invalid-feedback ${errorClassName}`}>{error}</span>
      )}
    </div>
  );
};

export default InputField;
